import React from 'react'

import routes from '@utils/routes'
import { useScenarioAndAssociationsQuery } from '@api/scenarios/queries/useScenarioAndAssociationsQuery'
import useTimeValue from '@hooks/useTimeValue'
import { Card, CardContent } from '@components/layout/Card'
import { Grid, GridArea } from '@UILibrary/Grid'

import { ProjectionDisclaimer } from './ProjectionDisclaimer'
import { ScenarioHeader } from './ScenarioHeader'
import { PlanActions } from './PlanActions'
import styles from "./FrozenScenario.module.scss"

export const FrozenScenario = (scenarioData) => {
  const {
    scenario,
    assets,
    riskProfile
  } = useScenarioAndAssociationsQuery({
    tenantSlug: scenarioData.config.tenant.slug,
    scenarioID: scenarioData.scenario.baseScenario.id,
    defaultValues: scenarioData
  })

  const { usePresentValue } = useTimeValue({
    tenantSlug: scenarioData.config.tenant.slug,
    clientId: scenarioData.config.userDetails.client_id,
    defaultValue: scenarioData.config.timeValue
  })

  return (
    <Grid className={styles.frozenScenarioLayout}>
      <GridArea name='header'>
        <ScenarioHeader
          label={'Plan name'}
          scenario={{
            name: scenario.data.baseScenario.name || 'My plan',
            status: scenario.data.baseScenario.status,
            planType: scenario.data.baseScenario.planType,
          }}
          updateScenario={scenario.actions.update}
        />
      </GridArea>
      <GridArea name='plan-actions'>
        <PlanActions
          scenario={{
            id: scenario.data.baseScenario.id,
            name: scenario.data.baseScenario.name,
            status: scenario.data.baseScenario.status,
            planType: scenario.data.baseScenario.planType,
          }}
          assets={assets.data}
          riskProfile={riskProfile.data.baseRiskProfile}
          comparedRiskProfile={riskProfile.data.comparedRiskProfile}
          updateScenario={scenario.actions.update}
          tenantSlug={scenarioData.config.tenant.slug}
          clientId={scenarioData.config.userDetails.client_id}
          clientHasIdentificationNumber={scenarioData.config.userDetails.clientHasIdentificationNumber}
          clientCellphoneNumber={scenarioData.config.userDetails.client_cellphone_number}
          usePresentValue={usePresentValue}
          existingAstuteRequest={scenarioData.config.userDetails.clientAstuteRequestExists}
          jointScenarioId={scenarioData.config.userDetails.jointScenarioId}
          isClient={scenarioData.config.userDetails.isClient}
          userDetails={{ profileId: scenarioData.config.userDetails.profile_id }} />
      </GridArea>
      <GridArea name='forecast' className={styles.frozenScenarioPDFReportArea}>
        <Card className='ui-card ui-card--projections-chart projection-report'>
          <CardContent className='projection-report__content'>
            <iframe
              src={routes.showScenarioReportPath({
                tenantSlug: scenarioData.config.tenant.slug,
                clientId: scenarioData.config.userDetails.client_id,
                scenarioId: scenario.data.baseScenario.id,
              })}
              title="Scenario report" width="100%" height="100%"></iframe>
          </CardContent>
        </Card>
      </GridArea>
      <GridArea name='disclaimer'>
        <ProjectionDisclaimer projectionDisclaimer={scenarioData.config.tenant.projectionDisclaimer} />
        <ProjectionDisclaimer projectionDisclaimer={scenarioData.config.tenant.historicalProjectionDisclaimer} />
      </GridArea>
    </Grid>
  )
}
